import { PdenSourceEnum } from "../../../models/pdenDataSourceSetting";

export enum NormalizeBySetting {
  NormalizeByActual = 0,
  NormalizeByValnav = 1,
  NormalizeByUser = 2
}

export enum Precision {
  Default = 0,
  High = 1
}

export enum KeyType {
  CategoricalKey = 0, // ValueIndex in Rust
  IntKey = 1, // Integer in Rust
  FloatKey = 2, // Number in Rust
  DateKey = 3 // Date in Rust
}

export interface FieldValues {
  fieldName: string;
  bin?: {
    start: number;
    end: number;
    count: number;
  };
}

export interface StickDataRequest {
  fields: FieldValues[];
  pdenSource?: PdenSourceEnum;
  normalizeBySetting?: NormalizeBySetting;
  precision?: Precision;
  scenarioIds: string[];
}

export interface FieldResult {
  field: string;
  value: string[]; // categorical value
  key: string;
  keyType: KeyType;
  intData: number[];
  dateData: number[]; // int64 timestamps
  floatData: number[];
}

// Row-based data structure for Ant Design table
export interface StickRow {
  id: string; // Unique identifier for the row
  [field: string]: string | number | undefined; // Dynamic fields from the response
}
